export default __webpack_public_path__ + "assets/front/scss/error.30f16e528139448a03199cae6e713e51.css";